import { apiErrorClear } from '../../../../../../global/ducks/base-api';
import { getEmploymentPlans, postPensionEnrollment } from '../../../../../../global/ducks/benadmin-api';
import { PensionEnrollmentContributionType, PensionEnrollmentContributionTypePostValue, PensionEnrollmentPlan, PensionEnrollmentPlanType } from '../../../pension-enrollment/models/pension-enrollment-model';
import { setPensionEnrollmentInfo } from '../../../pension-enrollment/pension-enrollment-slice';
import { PensionEnrollmentFormValues } from '../../models/pension-enrollment-models';

export function EnrollPension(formValues: PensionEnrollmentFormValues, pensionPlans: PensionEnrollmentPlan[], employeeId, employmentId, dispatch, onSuccess) {

	const enrollments = {};

	formValues?.selectedPlans?.forEach((plan, idx) => {
		const selectedPlan = pensionPlans?.find(p => `${p?.plan_id}_${p?.plan_type}` === plan);
		if (!selectedPlan) return;
	
		const isPlanTypeValid = [PensionEnrollmentPlanType.RsvpPlan, PensionEnrollmentPlanType.DcPlan].includes(selectedPlan?.plan_type);
		const isTypeValid = formValues[`type${selectedPlan.plan_id}`] && isPlanTypeValid;
		let contributionType;
		let pretaxContribution;
	
		if (isTypeValid) {
			if (formValues[`type${selectedPlan.plan_id}`] === PensionEnrollmentContributionType.FixedAmount) {
				contributionType = PensionEnrollmentContributionTypePostValue.FixedAmount;
			} else {
				contributionType = PensionEnrollmentContributionTypePostValue.Percentage;
			}
			pretaxContribution = formValues[`amount${selectedPlan.plan_id}`];
		}
	
		enrollments[idx] = {
			plan_id: selectedPlan?.plan_id,
			plan_type: selectedPlan?.plan_type,
			pbpor_id: selectedPlan?.pbpor_id,
			effective_date: selectedPlan?.enrollment_date,
			employment_id: employmentId,
			bill_payer: formValues[`billingAccountType${selectedPlan.plan_id}`],
			pretax_contribution  : pretaxContribution,
			contribution_type : contributionType,
		};
	});
	

	const payloadData: any = {
		enroll_on_plan: formValues?.selectedPlans,
		enrollments: {
			enrollment: enrollments,
		},
		employee_id: employeeId,
		employment_id: employmentId,
	};



	dispatch(apiErrorClear());

	dispatch(
		postPensionEnrollment(
			employeeId,
			employmentId,
			payloadData,
			() => {
				dispatch(getEmploymentPlans(employmentId, (getResponse) => {
					dispatch(setPensionEnrollmentInfo(getResponse));
					onSuccess();
				}));
			},
		));

}


export function GetInitialPensionFormValue(formValue: PensionEnrollmentFormValues, plansAvailable: PensionEnrollmentPlan[]) {
	const updated = { ...formValue };
	plansAvailable.forEach(plan => {
		updated[`billingAccountType${plan.plan_id}`] = '';
		updated[`type${plan.plan_id}`] = '';
		updated[`amount${plan.plan_id}`] = '';
	});
	return updated;
}